// Shared theme + scoring helpers for report subcomponents.
// Keeping these flat (not a class / not a hook) so they tree-shake cleanly and
// stay easy to grep for when tweaking the color palette.

export const COLORS = {
  primary: "#1F382E",
  accent: "#C26D5C",
  sand: "#D4C9B6",
  success: "#2C5C43",
  warning: "#E2A03F",
  danger: "#A84632",
  border: "#E5E0D8",
  muted: "#5C665D",
};

export const stateColor = {
  good: COLORS.success,
  fair: "#5e7a4d",
  watch: COLORS.warning,
  bad: COLORS.danger,
  neutral: COLORS.muted,
};

/**
 * thresholdState — turn a raw metric value into a 4-tier state token used to
 * pick the dot color on Metric cards.
 *
 *   thresholds = [poor, fair, good]  // ascending sentinel values
 *   higherBetter = true => >= good is "good", >= fair is "fair", >= poor is
 *     "watch", else "bad"
 *   higherBetter = false flips the comparisons (used for metrics like DSO,
 *     Debt/EBITDA where lower is better).
 */
export function thresholdState(value, thresholds, higherBetter = true) {
  if (value === null || value === undefined) return "neutral";
  const [poor, fair, good] = thresholds;
  if (higherBetter) {
    if (value >= good) return "good";
    if (value >= fair) return "fair";
    if (value >= poor) return "watch";
    return "bad";
  }
  if (value <= good) return "good";
  if (value <= fair) return "fair";
  if (value <= poor) return "watch";
  return "bad";
}

export function ratingTone(rating) {
  switch (rating) {
    case "Strong":
    case "Healthy":
      return { bg: "bg-[#2C5C43]/10", text: "text-[#2C5C43]" };
    case "Watchlist":
      return { bg: "bg-[#E2A03F]/15", text: "text-[#9c6b1d]" };
    case "Stressed":
    case "Distressed":
    case "Critical":
      return { bg: "bg-[#A84632]/15", text: "text-[#A84632]" };
    case "Insufficient data":
    default:
      return { bg: "bg-[#E5E0D8]", text: "text-[#5C665D]" };
  }
}
